import { Outlet, useLocation } from 'react-router-dom';
import { RegistrationNavBar } from '../components/registrationNavBar';
import { Box } from '@mui/material';
import { BorrowerStepperProvider } from '../../../context/borrowerStepperContext';
import { useEffect, useState } from 'react';
import { AppRoutes } from '../../../constants/appRoutes';
import { LocalStorageKey } from '../../../constants/localStorageKeys';

export const BorrowerRegistration = () => {
	const { pathname } = useLocation();
	const [isHidePlatform, setIsHidePlatform] = useState(true);
	const [isHideHeader, setIsHideHeader] = useState(false);

	useEffect(() => {
		setIsHidePlatform(
			pathname.includes(`${AppRoutes.BorrowerRegistartion}/${AppRoutes.IRegFirstStep}`)
		);
		setIsHideHeader(sessionStorage.getItem(LocalStorageKey.isEligibilityCompleted) !== '1');
	}, [pathname]);

	const isReg = window.location.pathname.includes(`${AppRoutes.BorrowerRegistartion}/${AppRoutes.IRegFirstStep}`);

	const hideHeader = () => {
		if (isReg) {
			if (isHideHeader) {
				return <RegistrationNavBar isShowPlatform={!isHidePlatform}></RegistrationNavBar>;
			}
			return null;
		}
		return <RegistrationNavBar isShowPlatform={!isHidePlatform}></RegistrationNavBar>;
	};

	return (
		<>
			<BorrowerStepperProvider>
				{hideHeader()}
				<Box className={`h-auto ${!isReg ? 'flex justify-center items-center' : ''}`}>
					<Box className={`${!isReg ? 'xl:w-[1140px] md:my-8 m-4' : ''} w-full h-full`}>
						<Outlet />
					</Box>
				</Box>
			</BorrowerStepperProvider>
		</>
	);
};
